import React from "react";

export default function ManageRepairs({
  cards,
  title,
  description,
  chipTxt,
  id,
  iconStyle,
}) {
  const defaultIconStyle = {
    filter:
      "invert(44%) sepia(8%) saturate(7470%) hue-rotate(97deg) brightness(126%) contrast(53%)",
  };

  return (
    <div id={id} className="lg:max-w-[1440px] w-full mx-auto">
      {" "}
      <div className=" w-full  md:px-12 px-5">
        {" "}
        <div className=" w-full mx-auto flex flex-col gap-4 md:gap-8 lg:gap-[64px] text-white py-8 md:py-[64px] ">
          <div className="flex flex-col gap-3 md:gap-4  lg:gap-6  ">
            <h5 className="bg-[#3CAB5C1A] text-[#3CAB5C] px-3 py-1 rounded-full  border border-[#3CAB5C] font-medium w-fit">
              {chipTxt}
            </h5>
            <div className="flex gap-8 md:flex-row flex-col  ">
              {" "}
              <h1
                className={` ${
                  title == "Ready to Work Jobs That Fit Your Schedule"
                    ? "flex-[1.1]"
                    : "flex-1"
                } font-medium w-full   text-[#242424] text-[24px] md:text-[48px] leading-tight sm:leading-tight md:leading-tight lg:leading-[69px] tracking-[0]`}
              >
                {title}
              </h1>
              <h2
                style={{}}
                className=" text-[#242424] flex-1 w-full text-[18px] md:text-[22px]  mt-4"
              >
                {description}
              </h2>
            </div>
          </div>
          <div className="flex gap-[10px] md:flex-row flex-col w-full">
            {cards.map((card, index) => (
              <div
                key={index}
                className="bg-[#F6F7F9] w-full py-6 md:py-8 px-6 rounded-[20px]"
              >
                <img
                  style={iconStyle ?? defaultIconStyle}
                  src={card.icon}
                  alt={card.title}
                  className="mb-5 w-[48px] h-[48px]"
                />
                <h2 className="text-[#242424] text-[18px] md:text-[22px] font-semibold  mb-4 md:mb-8">
                  {card.title}
                </h2>
                <h4
                  style={{ letterSpacing: "0.001em" }}
                  className="text-[#242424] md:text-[18px] text-[14px]"
                >
                  {card.description}
                </h4>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
